import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import { type IntlService } from 'ember-intl'
import { isWithinNorthAmericanSummer } from 'teacher-ui-client/utils/dates'
import SideNavItem from 'teacher-ui-client/components/side-nav/item'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import catchUpGuides from '@images/icons/catch-up-guides.svg'

export class CatchUpGuidesLink extends Component {
  @service sideNav!: SideNavService

  @service intl!: IntlService

  get isVisible() {
    return this.sideNav.showCatchUpGuides
  }

  get linkLabel() {
    return isWithinNorthAmericanSummer(new Date())
      ? this.intl.t('sideNav.reading.catchUpGuidesSummer')
      : this.intl.t('sideNav.reading.catchUpGuides')
  }

  <template>
    {{#if this.isVisible}}
      <SideNavItem data-test-side-nav-catch-up-guides @linkTo="subscription-type.catch-up-guides">
        <SideNavIconComponent @url={{catchUpGuides}} @alt="Lightbulb" />
        <span> {{this.linkLabel}}</span>
      </SideNavItem>
    {{/if}}
  </template>
}

export default CatchUpGuidesLink
